const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const BackgroundLabelCommandURL: any = {
    UploadBackgroundLabel: Backofficebff + '/v1/BackgroundLabel/upload',
    DeleteBackgroundLabel: Backofficebff + '/v1/BackgroundLabel/delete',
    UpdateBackgroundLabelDisplayOrder: Backofficebff + '/v1/BackgroundLabel/update-display-order',
};

